import withAdminRole from './withAdminRole';
export default withAdminRole;
